import type { OfflineSyncPayload } from './offlineSyncPayload.ts';

/** Default max JSON body size for a single offline sync POST (~8 MB). */
export const DEFAULT_SYNC_UPLOAD_MAX_PAYLOAD_BYTES = 8_000_000;

export const SYNC_UPLOAD_PAYLOAD_TOO_LARGE_ES =
  'El envío supera el tamaño máximo permitido. Sincronice de a un registro o libere espacio en Almacenamiento.';

export const SYNC_UPLOAD_SINGLE_RECORD_TOO_LARGE_ES =
  'Un registro con fotos o firmas supera el tamaño máximo de envío. Reduzca las imágenes o sincronice desde otro dispositivo.';

/** UTF-8 byte length of the wire JSON body. */
export function estimateOfflineSyncPayloadBytes(payload: OfflineSyncPayload): number {
  return new TextEncoder().encode(JSON.stringify(payload)).byteLength;
}

export function exceedsSyncUploadMaxPayloadBytes(payload: OfflineSyncPayload, maxBytes: number): boolean {
  if (!Number.isFinite(maxBytes) || maxBytes <= 0) return false;
  return estimateOfflineSyncPayloadBytes(payload) > maxBytes;
}
